import tmhRequest from '@/config/tmhRequest'

export default {
    searchCheckWorkCount: function (data) {
        return tmhRequest({
            url: '/employee/tmh/checkwork/searchcheckworkcount',
            method: 'post',
            data: data,
        })
    },

    searchCheckWorkByPage: function (data) {
        return tmhRequest({
            url: '/employee/tmh/checkwork/searchcheckworkbypage',
            method: 'post',
            data: data,
        })
    },

    addCheckWork: function (data) {
        return tmhRequest({
            url: '/employee/tmh/checkwork/addcheckwork',
            method: 'post',
            params: data,
        })
    },

    deleteCheckWork: function (data) {
        return tmhRequest({
            url: '/employee/tmh/checkwork/deletecheckwork',
            method: 'post',
            data: data,
        })
    },

    exportCheckWork: function (data) {
        return tmhRequest({
            url: '/employee/tmh/checkwork/exportcheckwork',
            method: 'post',
            responseType: 'blob',
            data: data,
        })
    },
} 


// WEBPACK FOOTER //
// ./src/api/tmh/employee/checkwork.js